import React from 'react';
import { ItableColumn } from 'components/Table/type';
import { IqueryResults, EnumQueryResults, EnumDetail } from '../../init';

export const getColumns = (controlData: IqueryResults): ItableColumn[] => {
  return [
    {
      title: '',
      field: 'selected',
    },

    {
      title: '項次',
      field: 'itemNo',
    },
    {
      title: '體系別',
      field: EnumDetail.retailerName,
    },
    {
      title: (
        <div>
          分店
          <br />
          倉庫名稱
        </div>
      ),
      field: EnumDetail.buyerGLN,
      show: controlData[EnumQueryResults.storeNo],
      dataTitle: '分店倉庫名稱',
    },
    {
      title: '訂單號碼',
      field: EnumDetail.orderNo,
      show: controlData[EnumQueryResults.orderNo],
    },
    {
      title: '訂單日期',
      field: EnumDetail.orderDate,
      show: controlData[EnumQueryResults.orderDate],
    },
    {
      title: '訂單有效日',
      field: EnumDetail.orderExpireDate,
      show: controlData[EnumQueryResults.orderExpireDate],
    },
    {
      title: '送貨起始日',
      field: EnumDetail.deliverStartDate,
      show: controlData[EnumQueryResults.deliverStartDate],
    },
    {
      title: '送貨截止日',
      field: EnumDetail.deliverEndDate,
      show: controlData[EnumQueryResults.deliverEndDate],
    },
    {
      title: '備註',
      field: EnumDetail.announcement,
      show: controlData[EnumQueryResults.announcement],
    },
    {
      title: '廠編',
      field: EnumDetail.supplierCode,
      show: controlData[EnumQueryResults.supplierCode],
    },
    {
      title: '廠商簡稱',
      field: EnumDetail.supplierBriefName,
      show: controlData[EnumQueryResults.supplierBriefName],
    },
    {
      title: '採購組織',
      field: EnumDetail.typeName,
      show: controlData[EnumQueryResults.typeName],
    },
    {
      title: '合約號碼',
      field: EnumDetail.buildNo,
      show: controlData[EnumQueryResults.buildNo],
    },
    {
      title: '送貨期間',
      field: 'deliverDate1',
      show: controlData[EnumQueryResults.deliverDate1],
    },
    {
      title: '送貨期間',
      field: 'deliverDate2',
      show: controlData[EnumQueryResults.deliverDate2],
    },

    {
      title: '訂單狀態',
      field: EnumDetail.orderStatus,
      show: controlData[EnumQueryResults.orderStatus],
    },

    {
      title: '點閱紀錄',
      field: EnumDetail.viewed,
      show: controlData[EnumQueryResults.viewed],
    },
    {
      title: (
        <div>
          文字檔
          <br />
          下載紀錄
        </div>
      ),
      field: EnumDetail.downloaded,
      show: controlData[EnumQueryResults.downloaded],
      dataTitle: '文字檔下載紀錄',
    },
    {
      title: '訂單屬性',
      field: EnumDetail.orderType,
      show: controlData[EnumQueryResults.orderType],
    },
    {
      title: '最後異動時間',
      field: EnumDetail.updDate,
      // show: controlData[EnumQueryResults.updDate] ,
    },
  ];
};
export default getColumns;
